<template>
  <v-container>
    <v-card
      style="background-color: transparent; border-radius: 15px"
      elevation="1"
      width="100vw"
      heigth="100px"
    >
      <v-card-text>
        <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
        <div v-else>
          <AppCalendar
            :items="events"
            @adiar="adiar"
            @participate-general-class="confirmGeneralClassParticipation"
            @decline-general-class="declineGeneralClassParticipation"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import AppCalendar from "@/components/calendar/calendar";
import customerApi from "@/shared/pitchCustomerApi";

export default {
  name: "CustomerCalendar",
  components: { AppCalendar },
  created() {
    this.loadData();
  },
  data() {
    return {
      loading: true,
      events: [],
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      customerApi.calendar().then((res) => {
        this.events = res.data.events;
        this.loading = false;
      });
    },
    adiar(item) {
      let request;
      const { action } = item;
      switch (action) {
        case "cancel": {
          if (window.confirm("Confirmar cancelamento da aula?")) {
            request = customerApi.cancelarAula(item.item.id);
          }
          break;
        }
        case "next": {
          request = customerApi.adiarParaProxima(item.item.id);
          break;
        }
        case "other": {
          request = customerApi.postergate(item.item.id, item.item.data);
          break;
        }
        default:
          return;
      }
      request.then(() => {
        this.$root.$emit("display-alert", {
          text: "solicitação de alteração enviada! 😉",
          type: 0,
        });
        this.loadData();
      });
    },
    async confirmGeneralClassParticipation(id) {
      try {
        const res = await customerApi.participateInGeneralClass(id);

        this.$root.$emit("display-alert", {
          text: res.data?.alreadyConfirmed
            ? "Sua participação nessa aula geral já estava confirmada."
            : "Participação confirmada com sucesso!",
          type: 0,
        });

        this.loadData();
      } catch (err) {
        this.$root.$emit("display-alert", {
          text:
            err?.response?.data?.message ||
            "Não foi possível confirmar sua participação agora.",
          type: 1,
        });
      }
    },
    async declineGeneralClassParticipation(id) {
      try {
        await customerApi.declineGeneralClass(id);

        this.$root.$emit("display-alert", {
          text: "Você optou por não participar desta aula.",
          type: 0,
        });

        this.loadData();
      } catch (err) {
        this.$root.$emit("display-alert", {
          text:
            err?.response?.data?.message ||
            "Não foi possível atualizar sua participação agora.",
          type: 1,
        });
      }
    },
  },
};
</script>
